var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlaque = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.55 55.06h-29v-.87c0-2.39-1.66-4.34-3.61-4.34H29v-19.7h.9c2 0 3.56-2 3.61-4.34v-.87h29v.87c0 2.39 1.66 4.34 3.61 4.34h.92v19.7h-.9c-2 0-3.55 1.94-3.55 4.32l-.04.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.55 56h-31v-1.79c0-1.85-1.23-3.42-2.61-3.42H28V29.21h1.9c1.38 0 2.58-1.57 2.61-3.42V24h31v1.79c0 1.85 1.23 3.42 2.61 3.42H68v21.58h-1.9c-1.39 0-2.55 1.55-2.55 3.38V56Zm-29-1.88h27c0-2.84 2-5.15 4.45-5.21V31.09c-2.42-.06-4.43-2.37-4.51-5.21h-27c-.06 2.84-2.06 5.12-4.49 5.21v17.82c2.43.09 4.43 2.37 4.51 5.21h.04Z"
  })));
};
export default SvgPlaque;